import { PartialType } from '../../../utils';
import { CreateMessagingTemplateDto } from './create-messaging-template.dto';
export class UpdateMessagingTemplateDto extends PartialType(CreateMessagingTemplateDto) {
}
